/**
 * Swiper controller responisble for creating an instance of a Swiper class with required modules (by a component)
 */
// Add other modules if needed: https://swiperjs.com/swiper-api#modules
import { Swiper, Mousewheel, Navigation, Pagination, Scrollbar, FreeMode, Manipulation, } from 'swiper';
/**
 * BSSSwiperController class
 */
var BSSSwiperController = /** @class */ (function () {
    function BSSSwiperController(_a) {
        var _b = _a.selector, selector = _b === void 0 ? '' : _b, _c = _a.configuration, configuration = _c === void 0 ? null : _c, _d = _a.modules, modules = _d === void 0 ? null : _d;
        this._selector = selector;
        this._configuration = configuration;
        this._modules = modules;
        this._addModules(this._modules);
    }
    /**
     * @desc Add requierd modules to a swiper class
     * @param componentModules array of required modules
     */
    BSSSwiperController.prototype._addModules = function (componentModules) {
        var modules = [];
        // always add 'Manipulation' module as its methods are required for possible cases of switching off product on components' critical errors
        modules.push(Manipulation);
        componentModules === null || componentModules === void 0 ? void 0 : componentModules.forEach(function (module) {
            switch (module) {
                case 'Mousewheel':
                    modules.push(Mousewheel);
                    break;
                case 'Navigation':
                    modules.push(Navigation);
                    break;
                case 'Pagination':
                    modules.push(Pagination);
                    break;
                case 'Scrollbar':
                    modules.push(Scrollbar);
                    break;
                case 'FreeMode':
                    modules.push(FreeMode);
                    break;
            }
        });
        Swiper.use(modules);
    };
    /**
     * @desc Init and return swiper instance with modules
     * @returns swiper instance with modules
     */
    BSSSwiperController.prototype.getSwiper = function () {
        return new Swiper(this._selector, this._configuration || {});
    };
    return BSSSwiperController;
}());
export default BSSSwiperController;
